import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { reducers } from './reducers';
import { EffectsModule } from '@ngrx/effects';
import { FuelCardsEffects } from './effects/fuel-cards.effects';

@NgModule({
  imports: [
    StoreModule.forFeature('fuel', reducers),
    EffectsModule.forFeature([FuelCardsEffects]),
  ]
})
export class FuelCardStoreModule {}
